import { render, staticRenderFns } from "./IndividualPTOPolicy.vue?vue&type=template&id=30773c59&scoped=true&"
import script from "./IndividualPTOPolicy.vue?vue&type=script&lang=ts&"
export * from "./IndividualPTOPolicy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30773c59",
  null
  
)

export default component.exports